<form [formGroup]="formGroup">
  <ng-container formArrayName="array">
    <jtm-button
      class="pull-right d-flex w-100 justify-content-end"
      (clicked)="addItem()"
      [disabled]="disabled"
      [label]="addButtonLabel"
      [size]="buttonSizes.Medium"
      [variant]="buttonVariants.Secondary"
    >
      <i class="up-icon add-dark on-idp-button"></i>
    </jtm-button>
    @for (item of formControls; track item; let i = $index) {
      <div class="row form-row row-margin">
        <div class="col-11 position-relative">
          <app-form-group-input
            type="text"
            [id]="i"
            [name]="$any(i)"
            [formControlName]="i"
            [required]="true"
            [disabled]="disabled"
            (keydown.enter)="$event.preventDefault()"
            [customTrim]="true"
            [errorMessages]="errorMessages"
          ></app-form-group-input>
          @if (transformedDataSet[item.value]?.status; as status) {
            <div>
              @if (status === 'VERIFIED') {
                <i class="fas fa-check-circle text-success icon-inline" title="Verified"></i>
              }
              @if (status === 'PENDING') {
                <span>
                  <ul class="list-none p-0">
                    <li>DNS Validation Status: Pending</li>
                    <li>String : jumio-up-idp-domain-verification={{ transformedDataSet[item.value]?.verificationToken }}</li>
                  </ul>
                </span>
              }
              @if (status === 'NOT_VALIDATED') {
                <i class="fas fa-times-circle text-danger icon-inline" title="Not Validated"></i>
              }
            </div>
          }
        </div>
        <div class="col-1 reset-btn">
          @if (transformedDataSet[item.value]?.status === 'NOT_VALIDATED') {
            <button
              type="button"
              class="button pull-right"
              (click)="onResetDnsValidation.emit({domain: item.value, index: i})"
              [title]="'Reset DNS Challenge'"
              data-cy="reset-dns-validation-button"
            >
              <i class="fas fa-sync"></i>
            </button>
          }
          <button
            type="button"
            class="button hover-red pull-right"
            (click)="onRemoveButtonClick(i)"
            [disabled]="(required && onlyOneRowLeft()) || disabled"
            [title]="removeButtonTooltip()"
          >
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>
    }
  </ng-container>
</form>
